import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    
    /** 获取配送费列表 **/
    GET_ORDER_LIST(data) {
        controller='EsOrder';
        action='GetOrderList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取配送费详情 **/
    GET_ORDER_INFO(data) {
        controller='EsOrder';
        action='GetOrderInfo';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

}